import type {
  BookingNoteAttachmentCreateApiData,
  BookingNoteAttachmentCreateApiResponses,
  BookingNoteAttachmentDeleteApiData,
  BookingNoteAttachmentDeleteApiResponses,
  BookingNoteAttachmentsBulkCreateApiData,
  BookingNoteAttachmentsBulkCreateApiResponses,
  BookingNoteCreateApiData,
  BookingNoteCreateApiResponses,
  BookingNoteDeleteApiData,
  BookingNoteDeleteApiResponses,
  BookingNoteGetApiData,
  BookingNoteGetApiResponses,
  BookingNoteListApiData,
  BookingNoteListApiResponses,
  BookingNotePatchApiData,
  BookingNotePatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { noteAttachmentFilesFormData } from '../noteAttachmentFormData';

// Booking notes

export const getBookingNoteUrls = {
  getPaginatedBookingNotes: dataEndpoint<BookingNoteListApiData, BookingNoteListApiResponses>({
    getUrl: (queryParams) => apiUrl('booking-notes/', queryParams)
  }),
  getBookingNote: dataEndpoint<BookingNoteGetApiData, BookingNoteGetApiResponses>({
    getUrl: ({ bookingNoteId }) => apiUrl(`booking-notes/${bookingNoteId}/`)
  }),
  postCreateBookingNote: responseEndpoint<BookingNoteCreateApiData, BookingNoteCreateApiResponses>({
    getUrl: () => apiUrl('booking-notes/'),
    getBody: (data) => data
  }),
  patchBookingNote: responseEndpoint<BookingNotePatchApiData, BookingNotePatchApiResponses>({
    getUrl: ({ bookingNoteId }) => apiUrl(`booking-notes/${bookingNoteId}/`),
    getBody: ({ bookingNoteId: _, ...body }) => body
  }),
  deleteBookingNote: dataEndpoint<BookingNoteDeleteApiData, BookingNoteDeleteApiResponses>({
    getUrl: ({ bookingNoteId }) => apiUrl(`booking-notes/${bookingNoteId}/`)
  }),
  /**
   * The worker app's upload: React Native hands multipart a `{ uri, name, type }` object
   * where the web has a `File`, so the mobile shape gets its own input.
   */
  postBookingNoteAttachmentMobile: responseEndpoint<
    BookingNoteAttachmentCreateApiData,
    BookingNoteAttachmentCreateApiResponses,
    { bookingNoteId: number; fileData: { uri: string; name: string; type: string } }
  >({
    getUrl: ({ bookingNoteId }) => apiUrl(`booking-notes/${bookingNoteId}/attachments/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ fileData }) => {
      const formData = new FormData();
      //@ts-expect-error React Native image shape for multipart
      formData.append('file', fileData);
      return formData;
    },
    skipBodyTransformation: true
  }),
  postBookingNoteAttachmentsBulk: responseEndpoint<
    BookingNoteAttachmentsBulkCreateApiData,
    BookingNoteAttachmentsBulkCreateApiResponses
  >({
    getUrl: ({ bookingNoteId }) => apiUrl(`booking-notes/${bookingNoteId}/attachments/bulk/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ files }) => noteAttachmentFilesFormData(files),
    skipBodyTransformation: true
  }),
  deleteBookingNoteAttachment: dataEndpoint<
    BookingNoteAttachmentDeleteApiData,
    BookingNoteAttachmentDeleteApiResponses
  >({
    getUrl: ({ bookingNoteId, attachmentId }) => apiUrl(`booking-notes/${bookingNoteId}/attachments/${attachmentId}/`)
  })
};
